import {UrlManager} from './types';

export class WindowUrlManager implements UrlManager {
  getPath() {
    return window.location.pathname;
  }

  getHash() {
    return window.location.hash;
  }

  getQueryStringParam(paramName: string) {
    let paramVal = new URLSearchParams(window.location.search).get(paramName);
    if (paramVal === null) {
      paramVal = new URLSearchParams(window.location.hash).get(paramName); // wtf dashboards
    }
    return paramVal;
  }

  getLocation() {
    return window.location;
  }

  setLocation(url) {
    window.location.assign(url);
  }

  openInNewTab(...args) {
    window.open(...args);
  }

  historyReplaceState(data: any, unused: string, url: string | URL) {
    window.history.replaceState(data, unused, url);
  }

  historyPushState(data: any, unused: string, url: string | URL) {
    window.history.pushState(data, unused, url);
  }
}
